/**
 * CSS class names and rendering constants for site plan overlays.
 *
 * Why this file exists:
 * - Single source of truth for class names used across plugins, handlers, and overlay factories.
 * - Separates the "what" (class names) from the "when" (event wiring in plugins and handlers).
 * - Mirrors the markersBehavior.js pattern so both feature areas follow the same convention.
 *
 * @module searchResultsMap/services/sitePlanBehavior
 */

/**
 * CSS class names for site plan overlay DOM elements.
 *
 * Consumed by:
 *   - sitePlan.plugin / interactiveSitePlan.plugin: passed as `classNames` to overlay factories
 *   - staticSitePlanHandlers / interactiveSitePlanHandlers: active class for hover state
 */
export const SITE_PLAN_CLASS_NAMES = {
  container:   'nhs-c-site-plan__container',
  image:       'nhs-c-site-plan__image',
  mask:        'nhs-c-site-plan__mask',
  active:      'nhs-c-site-plan__image--active',
  layerPrefix: 'nhs-c-site-plan__layer--',
};

/**
 * CSS class name applied to all lot polygon <path> elements.
 *
 * Values must match the path state selectors in _components.site-plan.scss.
 */
export const LOT_CLASS_NAMES = {
  active: 'nhs-c-site-plan__lot--active',
};
